import React from "react";
import { Box } from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import type { ConnectionStatus } from "../../hooks/useSSE";

/** Red-family text that stays readable on white (6.5:1); the brand has no red of its own. */
const DISCONNECTED_TEXT = "#A32D2D";
const RECONNECTING_TEXT = "#B4560F";

interface ConnectionNoticeProps {
  status: ConnectionStatus;
  compact?: boolean;
}

/**
 * Live-stream health for the ticket toolbar. Being connected is the normal state, so it
 * renders nothing; the notice only appears when chat can't stream.
 */
function ConnectionNotice({ status, compact = false }: ConnectionNoticeProps) {
  if (status === "connected") return null;

  const isRetrying = status === "connecting" || status === "reconnecting";
  return (
    <Box
      role="status"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        mr: compact ? 0.5 : 1,
        fontFamily: "var(--theo-font-sans)",
        fontSize: compact ? 11 : 12,
        fontWeight: 500,
        whiteSpace: "nowrap",
        color: isRetrying ? RECONNECTING_TEXT : DISCONNECTED_TEXT,
      }}
    >
      <LinkOffIcon sx={{ fontSize: compact ? 13 : 15 }} />
      {isRetrying ? "Reconnecting…" : "Disconnected"}
    </Box>
  );
}

export default ConnectionNotice;
